export const KNOWLEDGE = {
    LIST_KNOWLEDGE_START: 'KNOWLEDGE/LIST_KNOWLEDGE_START', 
    LIST_KNOWLEDGE_SUCCEEDED: 'KNOWLEDGE/LIST_KNOWLEDGE_SUCCEEDED',
    LIST_KNOWLEDGE_FAILED: 'KNOWLEDGE/LIST_KNOWLEDGE_FAILED',
    KB_BASE: "ARTICLE",
    KB_SUPPORT_ARTICLE: "Self Help Article",
    ANNOUNCEMENTS: "Announcements",
    OUTAGE: "OUTAGE"
}
